import './HallOfWood.css'
import { useState } from 'react'
import ss1Image from '../assessts/ss1.JPEG';
import ss2Image from '../assessts/ss2.JPEG';
import ss3Image from '../assessts/ss3.jpeg';
import ss4Image from '../assessts/IMG_2442.jpg'
import ss5Image from '../assessts/ss5.jpg'
import ss6Image from '../assessts/ss6.jpg'

export default function HallOfWood() {
    const [selectedSeason, setSelectedSeason] = useState(null)

    const seasons = [
        { id: 1, name: 'Season 1', image: ss1Image },
        { id: 2, name: 'Season 2', image: ss2Image },
        { id: 3, name: 'Season 3', image: ss3Image },
        { id: 4, name: 'Season 4', image: ss4Image },
        { id: 5, name: 'Season 5', image: ss5Image },
        { id: 6, name: 'Season 6', image: ss6Image }
    ]

    const handleSeasonClick = (season) => {
        setSelectedSeason(season)
    }

    return (
        <div className="hall-of-wood">
            <div className="hall-header">
                <h1 className="hall-title">Hall of Wood</h1>
                <p className="hall-subtitle">Champions Through the Seasons</p>
            </div>

            <div className="seasons-container">
                {seasons.map(season => (
                    <button
                        key={season.id}
                        className={`season-button ${selectedSeason?.id === season.id ? 'active' : ''} ${!season.image ? 'disabled' : ''}`}
                        onClick={() => season.image && handleSeasonClick(season)}
                        disabled={!season.image}
                    >
                        <span className="season-number">{season.id}</span>
                        <span className="season-name">{season.name}</span>
                    </button>
                ))}
            </div>

            {selectedSeason && selectedSeason.image && (
                <div className="champion-display">
                    <h2 className="champion-title">{selectedSeason.name} Champions</h2>
                    <div className="champion-image-container">
                        <img
                            src={selectedSeason.image}
                            alt={`${selectedSeason.name} Champion`}
                            className="champion-image"
                        />
                    </div>
                </div>
            )}

            {!selectedSeason && (
                <div className="placeholder-text">
                    <p>Select a season to view the champion</p>
                </div>
            )}
        </div>
    )
}
